var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 35.882L51 28.882L35.447 21.105C35.3081 21.0355 35.1549 20.9993 34.9995 20.9993C34.8441 20.9993 34.6909 21.0355 34.552 21.105L21 27.882L37 35.882Z",
    fill: "#E0E1FF",
    fillOpacity: 0.64
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 35.618V50.618L50.447 43.894C50.6132 43.8112 50.7531 43.6837 50.8507 43.5258C50.9484 43.3678 51.0001 43.1858 51 43V28.618L37 35.618Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 35.618L21 27.618V42C21 42.379 21.214 42.725 21.553 42.895L37 50.618V35.618Z",
    fill: "#E0E1FF",
    fillOpacity: 0.24
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 51,
    y1: 39.618,
    x2: 36.4446,
    y2: 37.1935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon1);
export default __webpack_public_path__ + "static/media/feature-icon-1.dd431a2558a4ecf52ba3be8a942798f8.svg";
export { ForwardRef as ReactComponent };